import { useQuery } from 'apollo-client'
import { constants } from 'helpers'
import { useFt } from 'hooks'

import mainPageBannerQuery from './graph/mainPageBanner.strapi.graphql'


const useStrapiMainPageBannerData = () => {
  const isStrapiMainPageBannersEnabled = useFt(constants.features.strapiMainPageBanners)

  const { data, isFetching } = useQuery(mainPageBannerQuery, {
    client: 'strapi',
    skip: !isStrapiMainPageBannersEnabled,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    context: {
      ssrCache: true,
    },
  })

  const mainPageBannerData = data?.mainPageBanner?.data?.attributes

  return {
    isFetching,
    data: mainPageBannerData,
  }
}

export default useStrapiMainPageBannerData
